// External packages
import * as React from 'react';

// Components
import { Card } from 'components/Card';

// Modules
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';

// Modules
import { AddVideoModal } from 'modules/videos/AddVideoModal';
import { VideoGallery } from 'modules/videos/VideoGallery';

// Hooks
import { useUploadMedia } from 'api/media';

export default function VideosPage() {
  const { mutate: uploadMedia, isPending: isUploading } = useUploadMedia();

  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between gap-x-8 gap-y-4">
        <h1 className="text-2xl text-gray-600">Videa</h1>
        <AddVideoModal
          isOpen={modalOpen}
          onOpenChange={setModalOpen}
          onSubmit={(data) => {
            uploadMedia(
              { file: data.video, fileType: 'videos' },
              {
                onSuccess: () => {
                  setModalOpen(false);
                },
              }
            );
          }}
          modalTrigger={
            <Button
              icon={<Icon name="plus" />}
              onPress={() => setModalOpen(true)}
            >
              Dodaj video
            </Button>
          }
          isPending={isUploading}
        />
      </div>
      <hr className="my-6 h-px text-gray-200" />
      <VideoGallery />
    </Card>
  );
}
